import 'slick';

( function( $ ) {
	'use strict';

	$( '.iconcard-carousel__slider' ).each( function() {

		const $this = $( this );
		if ( 1 < $this.children().length ) {
			$this.slick( {
				arrows: true,
				infinite: false,
				centerMode: true,
				dots: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 375,
				variableWidth: true,
				mobileFirst: true,
				swipe: true,
				fade: false,
				autoplay: false,
				adaptiveHeight: false,
				prevArrow: '<button class="prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M10 17.7142L2 9.35709M2 9.35709L10 0.99995M2 9.35709L14 9.35709L20 9.35709" stroke="black" stroke-width="1.5"/></svg></button>',
				nextArrow: '<button class="next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M10 1L18 9.35714M18 9.35714L10 17.7143M18 9.35714L6 9.35714L3.17557e-06 9.35714" stroke="black" stroke-width="1.5"/></svg></button>',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 1260,
						settings: {
							centerMode: false,
							slidesToShow: 1,
						}
					}
				]
			} );

			// add 1 of total slides
			$( '.slider-counter' ).text( '1 of ' + $this[0].slick.slideCount );

			// Update slider counter
			$this.on( 'beforeChange', function( event, slick, currentSlide, nextSlide ){
				var slideNumber = nextSlide + 1;
				var totalSlides = slick.slideCount;
				$( '.slider-counter' ).text( slideNumber + ' of ' + totalSlides );
			} );
		}
	} );
} )( jQuery );
